'use strict';

$(function() {
    var $html = $('html');
    var desktopClass = 'desktop';
    var mobileClass = 'mobile';
    var tabletClass = 'tablet';
    var tabletBreakpoint = 768;
    var desktopBreakpoint = 992;

    var initDeviceSwitch = function () {

        $html.removeClass();

        if (parseInt($(document).width()) >= desktopBreakpoint) {
            return $html.addClass(desktopClass);
        }

        if (parseInt($(document).width()) < desktopBreakpoint && parseInt($(document).width()) >= tabletBreakpoint) {
            return $html.addClass(tabletClass);
        }

        if (parseInt($(document).width()) <= tabletBreakpoint) {
            return $html.addClass(mobileClass);
        }
    };

    $(window).on('resize', function () {
        initDeviceSwitch();
    });

    initDeviceSwitch();
});
